'use client'

import { useAppDispatch, useAppSelector, useModals } from '@/lib/hooks'
import {
  setUserPin as setUserPinAction,
  setUserToken as setUserTokenAction,
} from '@/lib/redux'

export const useUser = () => {
  const dispatch = useAppDispatch()
  const appSession = useAppSelector((state) => state.appSession)

  const setUserPin = (pin: any[]) => {
    dispatch(setUserPinAction(pin))
  }

  const setUserToken = (token: string) => {
    dispatch(setUserTokenAction(token))
  }

  return {
    setUserPin,
    setUserToken,
    ...appSession,
  }
}
